<div class="tabs-wrapper no-select" [class.entering]="entering" [class.hidden]="isMeeting || isRespondingTypeform" *ngIf="!!profile">
  <div class="head center-children-vertically">
    <app-image class="logo" [width]="150" [height]="30" src="assets/logos/logo_wetalk.png" alt="logo"/>
  </div>
  <div class="mobile-hidden tabs-list">
    <ng-container *ngFor="let tab of tabs; let i = index">
      <div class="tab" [class]="{'selected': isTabSelected(tab)}" *ngIf="!tab.submenus" (click)="clickOnLink(tab.id)">
        <div class="tab-content">
          <div class="center-children">
            <app-icon class="icon" [class.icon-selected]="isTabSelected(tab)" [type]="tab.icon"></app-icon>
          </div>
          <div class="center-children tab-description"><div>{{ (tab.name[profile.role] ?? tab.name.all) | translate }}</div></div>
        </div>
      </div>
      <div class="tab" [class]="{'selected': isTabSelected(tab)}" *ngIf="tab.submenus">
        <div
          class="tab-content tab-content--submenu"
          [class.tab-content--submenu-open]="isSubmenuOpened(tab.id)"
          [dropdownTriggerFor]="submenuDropdown"
          dropdownPosition="end"
          (click)="toggleSubmenu(tab.id)">
          <div class="center-children">
            <app-icon class="icon" [class.icon-selected]="isTabSelected(tab)" [type]="tab.icon"></app-icon>
          </div>
          <div class="center-children tab-description"><div>{{ (tab.name[profile.role] ?? tab.name.all) | translate }}</div></div>
          <app-icon
            class="submenu-indicator"
            [class.submenu-indicator--selected]="isTabSelected(tab) || isSubmenuOpened(tab.id)"
            [class.submenu-indicator--open]="isSubmenuOpened(tab.id)"
            type="chevron-right">
          </app-icon>
        </div>
        <app-dropdown #submenuDropdown (closed)="closeSubmenu(tab.id)">
          <div class="submenu-list">
            <div class="submenu-item" *ngFor="let submenu of tab.submenus" (click)="clickOnLink(submenu.id)">
              {{ (submenu.name[profile.role] ?? submenu.name.all) | translate }}
            </div>
          </div>
        </app-dropdown>
      </div>
    </ng-container>
  </div>
  <div class="bottom-part">
    <div *ngxPermissionsExcept="'admin'" (click)="openFeedBackDialog()" class="feedback-container column gap">
      <div *ngIf="!rating" class="row gap center-children">
        <app-icon size="20" type="sad-emoji" color="#ff4f4f"/>
        <app-icon size="20" type="neutral-emoji" color="#FCC418"/>
        <app-icon size="20" type="laughy-emoji" color="#22C997"/>
      </div>
      <div *ngIf="rating" class="row gap center-children">
        <app-icon size="20" [color]="mapRatingValueToIconType(rating).color" [type]="mapRatingValueToIconType(rating).type"/>
        </div>

      <div class="center-horizontally-by-margin mobile-hidden">
        <span *ngIf="!rating; else elseBlock">{{ 'nav.satisfaction' | translate }}</span>
        <ng-template #elseBlock>
          <span>{{ 'nav.sentOn' | translate }} {{ feedbackDate }}</span>
        </ng-template>
      </div>
    </div>
    <div class="profile" *ngIf="!organizationSelected" (click)="goToProfile()">
      <div class="profile-icon" [style.color]="getColorByRole(profile.role)">
        <app-profile-icon [color]="getColorByRole(profile.role)" [isOnTabs]="true" [reload]="reloadImage$" [profile]="profile"></app-profile-icon>
      </div>
      <div class="mobile-hidden" >{{ capitalize(role) }}</div>
    </div>
    <div 
        class="profile" 
        *ngIf="organizationSelected" 
        matomoClickCategory="menuTalker"
        matomoClickAction="Click"
        matomoClickName="profileButton" 
        (click)="switchProfile()">
          <div class="profile-icon center-children">
            <div class="organization-icon center-children">
              <app-icon type="building" class="mobile-hidden"/>
              <app-icon type="building" class="desktop-hidden" size="10"/>
            </div>
          </div>
      <div class="mobile-hidden">{{ 'nav.pilot' | translate }}</div>
    </div>


    <div class="profile center-children mobile-hidden" *ngxPermissionsOnly="'pilot'" (click)="switchProfile()">
      {{ 'nav.switchAccount' | translate }}
    </div>
    <div class="power mobile-hidden" (click)="logout()">
      <div class="center-children">
        <app-icon type="power" />
      </div>
      <div class="tab-description">{{ (isImpersonating ? 'nav.backToAdmin' : 'nav.logout') | translate }}</div>
    </div>
    <div class="menu desktop-hidden center-children" [dropdownTriggerFor]="mobileTabs">
      <app-icon type="menu"/>
    </div>
  </div>
</div>
<div class="space"></div>

<app-dropdown #mobileTabs [isFilter]="true">
  <div class="tabs-list">
    <ng-container *ngFor="let tab of tabs">
      <div class="tab" [class]="{'selected': isTabSelected(tab)}" *ngIf="!tab.submenus" (click)="clickOnLink(tab.id)">
        <div class="tab-content">
          <div class="center-children">
            <app-icon class="icon" [class.icon-selected]="isTabSelected(tab)" [type]="tab.icon"/>
          </div>
          <div class="tab-description">{{ (tab.name[profile.role] ?? tab.name.all) | translate }}</div>
        </div>
      </div>
      <div *ngIf="tab.submenus" class="tab-with-submenu">
        <div class="tab" [class]="{'selected': isTabSelected(tab)}">
          <div class="tab-content tab-content--submenu tab-content--submenu-open">
            <div class="center-children">
              <app-icon class="icon" [class.icon-selected]="isTabSelected(tab)" [type]="tab.icon"/>
            </div>
            <div class="tab-description">{{ (tab.name[profile.role] ?? tab.name.all) | translate }}</div>
            <app-icon
              class="submenu-indicator"
              [class.submenu-indicator--selected]="isTabSelected(tab)"
              [class.submenu-indicator--open]="true"
              type="chevron-right">
            </app-icon>
          </div>
        </div>
        <div class="submenu-mobile">
          <div class="submenu-item" *ngFor="let submenu of tab.submenus" (click)="clickOnLink(submenu.id)">
            {{ (submenu.name[profile.role] ?? submenu.name.all) | translate }}
          </div>
        </div>
      </div>
    </ng-container>
    <hr />
    <div class="power" (click)="logout()">
      <div class="center-children">
        <app-icon type="power" />
      </div>
      <div class="tab-description">{{ (isImpersonating ? 'nav.backToAdmin' : 'nav.logout') | translate }}</div>
    </div>
  </div>
</app-dropdown>
